import DataTable from "@/components/ui/DataTable";
import { User } from "@/models/user.model";
import React from "react";
import { columns } from "./columns";
import Searchbar from "@/components/search/Searchbar";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { UserRoundPlus } from "lucide-react";

interface Props {
  users: User[];
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  setIsChange: React.Dispatch<React.SetStateAction<boolean>>;
}

function UsersDataTable({ users, search, setSearch, setIsChange }: Props) {
  const navigate = useNavigate();

  return (
    <div className="rounded-md w-full h-full p-5 bg-white outline outline-2 outline-gray-100 flex flex-col">
      <div className="flex justify-between items-center mb-6">
        <div className="font-bold text-2xl">All Staff</div>
        <Button onClick={() => navigate("/admin/register")}>
          <UserRoundPlus />
          <span className="ml-2">Add Staff</span>
        </Button>
      </div>

      <Searchbar search={search} setSearch={setSearch} />

      <div className="h-full max-h-full overflow-y-auto">
        <DataTable
          tableMinWidth="600px"
          columns={columns}
          data={users}
          tableCaption={`A total of ${users.length} staff members.`}
          containerClassname="max-h-[96%] overflow-y-auto relative mt-3"
        />
      </div>
    </div>
  );
}

export default UsersDataTable;
